.ae{flex-shrink:0;}